export default __webpack_public_path__ + "static/media/mass-res-white.1dd4f520.svg";